var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgARound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#FF7003",
    fillOpacity: 0.1,
    stroke: "#FF7003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.868 15.14H11.22L10.548 17H9.396L12.42 8.684H13.68L16.692 17H15.54L14.868 15.14ZM14.556 14.252L13.044 10.028L11.532 14.252H14.556Z",
    fill: "#FF7003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgARound);
export default __webpack_public_path__ + "static/media/a_round.2894187e77474994ca100a09def9918c.svg";
export { ForwardRef as ReactComponent };